import React from 'react';
import { Route } from 'react-router-dom';
import { keys } from 'lodash';

export function generateRouteComponents(routes)
{
    return keys(routes).map((key) =>
    {
        const route = routes[key];

        const props = route.props ? route.props : {};

        const Component = route.component;

        return <Route key={route.path} path={route.path} element={<Component {...props} />} />;
    });
}

export function hotelUrl(regionSlug, parentDestinationSlug, destinationSlug, hotelSlug)
{
    let url = `/destinations/${regionSlug}`;

    if (parentDestinationSlug)
    {
        url = `${url}/${parentDestinationSlug}`;
    }

    return `${url}/${destinationSlug}/${hotelSlug}`;
}

export function roomUrl(regionSlug, parentDestinationSlug, destinationSlug, hotelSlug, roomSlug)
{
    let url = `/destinations/${regionSlug}`;

    if (parentDestinationSlug)
    {
        url = `${url}/${parentDestinationSlug}`;
    }

    return `${url}/${destinationSlug}/${hotelSlug}/rooms/${roomSlug}`;
}

export function clusterUrl(regionSlug, parentDestinationSlug, destinationSlug, hotelSlug, clusterSlug)
{
    let url = `/destinations/${regionSlug}`;

    if (parentDestinationSlug)
    {
        url = `${url}/${parentDestinationSlug}`;
    }

    return `${url}/${destinationSlug}/${hotelSlug}/cluster/${clusterSlug}`;
}

export function destinationUrl(regionSlug, parentDestinationSlug, destinationSlug)
{
    let url = `/destinations/${regionSlug}`;

    if (parentDestinationSlug)
    {
        url = `${url}/${parentDestinationSlug}`;
    }

    return `${url}/${destinationSlug}`;
}
